module.exports = __webpack_public_path__ + "img/mp.68debd8c.svg";